import React from 'react'
import {Icon} from '@chakra-ui/react'

const DeliveryIcon = (props) => {
    return (
        <Icon viewBox="0 0 24 24" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.12602 19H0V2H15V7H19.4806L24 12.6492V19H20.874C20.4299 20.7252 18.8638 22 17 22C15.1362 22 13.5701 20.7252 13.126 19H9.87398C9.42994 20.7252 7.86384 22 6 22C4.13616 22 2.57006 20.7252 2.12602 19ZM20.874 17H22V13.3508L18.5194 9H15V14.5351C15.5883 14.1948 16.2714 14 17 14C18.8638 14 20.4299 15.2748 20.874 17ZM2.12602 17H2V4H13V17H9.87398C9.42994 15.2748 7.86384 14 6 14C4.13616 14 2.57006 15.2748 2.12602 17ZM6 20C7.10457 20 8 19.1046 8 18C8 16.8954 7.10457 16 6 16C4.89543 16 4 16.8954 4 18C4 19.1046 4.89543 20 6 20ZM19 18C19 19.1046 18.1046 20 17 20C15.8954 20 15 19.1046 15 18C15 16.8954 15.8954 16 17 16C18.1046 16 19 16.8954 19 18Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default DeliveryIcon
